import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { MasterHelper } from '../../utilities';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RegulationFilterModel } from '../../models/regulation';
import { ItemInfoDto } from '../../models/rulebook/item.info-dto';
import { UserProfile } from './../../models/user/user-profile.model';
import {  CookieOptionsArgs } from 'angular2-cookie/core';
//import { CookieService } from 'ngx-cookie';
import { RulebookFilterModel } from '../../models/rulebook/rulebook-filters-model';
import { SelfAssessmentFilter } from '../../models/self-assessment/self-assessment-filter';
import { ImpactAssessmentFilter } from '../../models/impact-assessment/impact-assessment-filter';
import { CookieService } from 'ngx-cookie-service';
import { ImpactAssessmentFilterT4 } from '../../models/impact-assessment/impact-assessmentT4-filter';
//import { CookieService } from 'angular2-cookie/services';
@Injectable({ providedIn: 'root' })
export class SessionService {

  tokenKey = environment.config.tokenKey;
  isLibraryTabActive =  false;
  newRulebookCount = 0;
  openLinkedUpdates = 0;
  actionedLinkedUpdates = 0;
  openRegulation = -1;
  futureRegulation = -1;
  otherRegulation = -1;
  actionedRegulation = -1;
  libraryRegulation = -1;
  regLibraryId = -1;
  rulebookUrl = '/library/rule-book';

  constructor(
    private cookieService: CookieService,
    private http: HttpClient,
  ) { }

  createSession(token: any): void {
    const option = {
      expires: new Date(MasterHelper.getExpirationDateTime()) 
      // secure: true
    };
    //this.cookieService.putObject(this.tokenKey, token, option);
    this.cookieService.set(this.tokenKey, token, option);
  }

  getSession(): Observable<UserProfile> {
    //const token = this.cookieService.getObject(this.tokenKey) as any;
     const token = this.cookieService.get(this.tokenKey) as any;
    return new Observable((observer) => {
      observer.next(token);
      observer.complete();
    });
  }

  getAccessToken(): UserProfile {
    return this.cookieService.get(this.tokenKey) as any;
    //return this.cookieService.getObject(this.tokenKey) as any;
  }


  getLoginUserInfo(): Observable<UserProfile> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<UserProfile>(`${environment.config.baseAppURL}/UserManagement/GetLoginUserInfo`, { headers });
  }

  isLoggedIn(): Observable<boolean> {
    return new Observable<boolean>(observer => {
      const token = this.cookieService.get(this.tokenKey) as string;
      //const token = this.cookieService.getObject(this.tokenKey) as string;
      observer.next(token ? true : false);
    });
  }

  logOut(): Observable<boolean> {
    this.cookieService.deleteAll();
    const persistFilter = JSON.parse(this.fetchFromBrowser('regulationFilter') as string) as RegulationFilterModel;
    const persistFilter2 = JSON.parse(this.fetchFromBrowser('impactAssessmentFilters') as string) as ImpactAssessmentFilter;
    const persistFilter3 = JSON.parse(this.fetchFromBrowser('selfAssessmentFilters') as string) as SelfAssessmentFilter;
    const persistFilter4 = JSON.parse(this.fetchFromBrowser('rulebookFilters') as string) as RulebookFilterModel;
    const persistFilterT4 = JSON.parse(this.fetchFromBrowser('impactAssessmentFiltersT4') as string) as ImpactAssessmentFilterT4;
    localStorage.clear();
    this.saveOnBrowser('regulationFilter', JSON.stringify(persistFilter));
    this.saveOnBrowser('impactAssessmentFilters', JSON.stringify(persistFilter2));
    this.saveOnBrowser('selfAssessmentFilters', JSON.stringify(persistFilter3));
    this.saveOnBrowser('rulebookFilters', JSON.stringify(persistFilter4));
    this.saveOnBrowser('impactAssessmentFiltersT4', JSON.stringify(persistFilterT4));
    return new Observable<boolean>(observer => {
      observer.next(false);
    });
  }

  logOutAudit(itemInfoDto: ItemInfoDto): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(itemInfoDto));
    return this.http.get<any>(`${environment.config.baseAppURL}/Authentication/Logout`, { headers });
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }
}
